import React, { useMemo, useState } from 'react'
import { motion } from 'motion/react'

import { EffectBackgroundProps, ParticleData } from '../types'

export const SparklesEffect = React.memo(({ layerStyle, index, values }: EffectBackgroundProps) => {
  const effectColors = useMemo(() => values.effectColors || ['#ffffff'], [values.effectColors])
  const effectSpeed = values.effectSpeed ?? 100
  const effectOpacity = values.effectOpacity ?? 100
  const effectBackgroundColor = values.effectBackgroundColor || '#000000'
  const opacityValue = effectOpacity / 100
  const particleColor = effectColors[0] || '#ffffff'

  const [sparkles] = useState(() => {
    const newParticles: Array<ParticleData> = []
    for (let i = 0; i < 60; i++) {
      newParticles.push({
        id: i,
        x: Math.random() * 100,
        y: Math.random() * 100,
        size: 2 + Math.random() * 4,
        duration: 0.8 + Math.random() * 1.5,
        delay: Math.random() * 3,
      })
    }
    return newParticles
  })

  return (
    <div
      style={{
        position: 'absolute' as const,
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        zIndex: -index - 1,
        backgroundColor: effectBackgroundColor,
      }}
    >
      {sparkles.map((particle) => (
        <div
          key={particle.id}
          style={{
            position: 'absolute',
            left: `${particle.x}%`,
            top: `${particle.y}%`,
          }}
        >
          {/* Main sparkle */}
          <motion.div
            style={{
              position: 'absolute',
              width: particle.size,
              height: particle.size,
              backgroundColor: particleColor,
              boxShadow: `0 0 ${particle.size * 3}px ${particleColor}`,
              borderRadius: '50%',
              left: '50%',
              top: '50%',
              transform: 'translate(-50%, -50%)',
            }}
            animate={{
              opacity: [0, opacityValue, 0],
              scale: [0, 1.5, 0],
            }}
            transition={{
              duration: particle.duration! * (100 / Math.max(effectSpeed, 1)),
              repeat: Infinity,
              ease: 'easeOut',
              delay: particle.delay,
            }}
          />
          {/* Cross sparkle effect - vertical */}
          <motion.div
            style={{
              position: 'absolute',
              width: particle.size * 0.3,
              height: particle.size * 2.5,
              backgroundColor: particleColor,
              filter: `blur(${particle.size * 0.2}px)`,
              left: '50%',
              top: '50%',
              transform: 'translate(-50%, -50%)',
            }}
            animate={{
              opacity: [0, opacityValue, 0],
              scaleY: [0, 1, 0],
            }}
            transition={{
              duration: particle.duration! * (100 / Math.max(effectSpeed, 1)),
              repeat: Infinity,
              ease: 'easeOut',
              delay: particle.delay,
            }}
          />
          {/* Cross sparkle effect - horizontal */}
          <motion.div
            style={{
              position: 'absolute',
              width: particle.size * 2.5,
              height: particle.size * 0.3,
              backgroundColor: particleColor,
              filter: `blur(${particle.size * 0.2}px)`,
              left: '50%',
              top: '50%',
              transform: 'translate(-50%, -50%)',
            }}
            animate={{
              opacity: [0, opacityValue, 0],
              scaleX: [0, 1, 0],
            }}
            transition={{
              duration: particle.duration! * (100 / Math.max(effectSpeed, 1)),
              repeat: Infinity,
              ease: 'easeOut',
              delay: particle.delay,
            }}
          />
        </div>
      ))}
    </div>
  )
})
SparklesEffect.displayName = 'SparklesEffect'
